import { useEffect } from 'react';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';

export const useInvBreadcrumbsEffect = (
  invoice:
    | {
        code: string;
        id: string;
      }
    | undefined
) => {
  useEffect(() => {
    if (!invoice) {
      return;
    }

    setBreadcrumbs([
      {
        name: 'Billing',
        path: '/works/billing',
      },
      {
        name: 'Invoices',
        path: '/works/billing/invoices',
      },
      {
        name: invoice.code,
        path: `/works/billing/invoices/${invoice.id}/hours`,
      },
    ]);
  }, [invoice]);
};
